import InternalLinkParser from "@/components/PageEditor/editor-components/shared/InternalLinkParser";
import { useEditor, useNode } from "@craftjs/core";
import { useEffect, useRef } from "react";
import ContentEditable from "react-contenteditable";
import Settings from "./Settings";
import Toolbar from "./Toolbar";

interface TextProps {
    text: string;
}

const PageIntro = ({ text = "" }: Partial<TextProps>) => {
    const editableRef = useRef<HTMLDivElement | null>(null);
    const {
        connectors: { connect },
        actions: { setProp },
    } = useNode((node) => ({
        parentNodeId: node.data.parent,
    }));
    const { enabled } = useEditor((state) => ({
        enabled: state.options.enabled,
    }));

    useEffect(() => {
        // Fix for nested divs being editable when they shouldn't exist due to a previous bug with pasting content.
        if (!editableRef.current) return;

        const editableDivs = editableRef.current.querySelectorAll("div[contenteditable='true']");

        for (let i = 0; i < editableDivs.length; i++) {
            const editableDiv = editableDivs[i] as HTMLDivElement;
            editableDiv.contentEditable = enabled.toString();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editableRef.current, enabled]);

    useEffect(() => {
        // Fix for pasted content sometimes having font-size attribute.
        if (!editableRef.current) return;

        const elementsWithFontSize = editableRef.current.querySelectorAll("[style*='font-size']");

        for (let i = 0; i < elementsWithFontSize.length; i++) {
            const element = elementsWithFontSize[i] as HTMLElement;
            element.style.fontSize = "";
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [editableRef.current, enabled]);

    if (!enabled)
        return (
            <div ref={(ref) => connect(ref!)} className="text-lg/[32px] font-medium mt-2 max-w-[920px]">
                <InternalLinkParser html={text} />
            </div>
        );

    return (
        <div ref={(ref) => connect(ref!)} className="text-lg/[32px] font-medium mt-2 max-w-[920px]">
            <ContentEditable
                html={text || ""}
                innerRef={editableRef}
                disabled={!enabled}
                onChange={(e) => {
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    setProp((props: any) => (props.text = e.target.value), 500);
                }}
                tagName="div"
                is={"p"}
            />
        </div>
    );
};

export default PageIntro;

PageIntro.craft = {
    displayName: "Introduction",
    props: {
        text: "Text",
    },
    related: {
        settings: Settings,
        toolbar: Toolbar,
    },
    rules: {
        canDrag: () => false,
        canDrop: () => false,
    },
};
